export const WorkOrderFilterSvg = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.5 3.45C1.5 3.02996 1.5 2.81994 1.58175 2.65951C1.65365 2.51839 1.76839 2.40365 1.90951 2.33175C2.06994 2.25 2.27996 2.25 2.7 2.25H15.3C15.72 2.25 15.9301 2.25 16.0905 2.33175C16.2316 2.40365 16.3463 2.51839 16.4183 2.65951C16.5 2.81994 16.5 3.02996 16.5 3.45V3.95205C16.5 4.15364 16.5 4.25444 16.4754 4.34817C16.4535 4.43123 16.4176 4.50993 16.3691 4.58082C16.3144 4.66082 16.2383 4.72684 16.0859 4.85887L11.2891 9.01613C11.1367 9.14816 11.0606 9.21418 11.0059 9.29418C10.9574 9.36507 10.9215 9.44377 10.8996 9.52683C10.875 9.62056 10.875 9.72136 10.875 9.92295V13.8438C10.875 13.9905 10.875 14.0638 10.8513 14.1272C10.8304 14.1832 10.7964 14.2334 10.7522 14.2736C10.7021 14.3192 10.634 14.3464 10.4978 14.4009L7.94783 15.4209C7.67218 15.5311 7.53435 15.5863 7.4237 15.5633C7.32695 15.5432 7.24204 15.4857 7.18744 15.4033C7.125 15.3091 7.125 15.1607 7.125 14.8638V9.92295C7.125 9.72136 7.125 9.62056 7.10037 9.52683C7.07854 9.44377 7.0426 9.36507 6.99413 9.29418C6.93943 9.21418 6.86326 9.14816 6.71092 9.01613L1.91408 4.85887C1.76174 4.72684 1.68557 4.66082 1.63087 4.58082C1.5824 4.50993 1.54646 4.43123 1.52463 4.34817C1.5 4.25444 1.5 4.15364 1.5 3.95205V3.45Z"
      stroke="#1D2939"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ScheduleCalendarSvg = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.25 5.83366H1.75M9.33333 1.16699V3.50033M4.66667 1.16699V3.50033M4.55 12.8337H9.45C10.4301 12.8337 10.9201 12.8337 11.2945 12.6429C11.6238 12.4751 11.8915 12.2074 12.0593 11.8781C12.25 11.5038 12.25 11.0138 12.25 10.0337V5.13366C12.25 4.15357 12.25 3.66352 12.0593 3.28918C11.8915 2.95989 11.6238 2.69218 11.2945 2.5244C10.9201 2.33366 10.4301 2.33366 9.45 2.33366H4.55C3.56991 2.33366 3.07986 2.33366 2.70552 2.5244C2.37623 2.69218 2.10852 2.95989 1.94074 3.28918C1.75 3.66352 1.75 4.15357 1.75 5.13366V10.0337C1.75 11.0138 1.75 11.5038 1.94074 11.8781C2.10852 12.2074 2.37623 12.4751 2.70552 12.6429C3.07986 12.8337 3.56991 12.8337 4.55 12.8337Z"
      stroke="#1369E9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DurationSvg = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6164_37714)">
      <path
        d="M6.99935 3.50033V7.00033L9.33268 8.16699M12.8327 7.00033C12.8327 10.222 10.221 12.8337 6.99935 12.8337C3.77769 12.8337 1.16602 10.222 1.16602 7.00033C1.16602 3.77866 3.77769 1.16699 6.99935 1.16699C10.221 1.16699 12.8327 3.77866 12.8327 7.00033Z"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6164_37714">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SpannerSvg = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.11876 4.45196C8.88775 4.22095 8.77224 4.10544 8.72897 3.97225C8.6909 3.85509 8.6909 3.72889 8.72897 3.61173C8.77224 3.47854 8.88775 3.36304 9.11876 3.13203L10.7745 1.47631C10.3351 1.27761 9.84736 1.16699 9.33379 1.16699C7.4008 1.16699 5.83379 2.734 5.83379 4.66699C5.83379 4.95343 5.8682 5.23183 5.93311 5.49829C6.00262 5.78363 6.03738 5.9263 6.03121 6.01643C6.02475 6.11079 6.01068 6.161 5.96716 6.24498C5.92559 6.32519 5.84596 6.40482 5.68669 6.5641L2.04212 10.2087C1.55888 10.6919 1.55888 11.4754 2.04212 11.9587C2.52537 12.4419 3.30888 12.4419 3.79212 11.9587L7.43669 8.3141C7.59596 8.15482 7.67559 8.07519 7.75581 8.03362C7.83978 7.99011 7.88999 7.97604 7.98435 7.96958C8.07448 7.96341 8.21715 7.99816 8.50249 8.06767C8.76895 8.13258 9.04735 8.16699 9.33379 8.16699C11.2668 8.16699 12.8338 6.59999 12.8338 4.66699C12.8338 4.15342 12.7232 3.66568 12.5245 3.22631L10.8688 4.88203C10.6377 5.11304 10.5222 5.22854 10.3891 5.27182C10.2719 5.30988 10.1457 5.30988 10.0285 5.27182C9.89534 5.22854 9.77983 5.11304 9.54882 4.88203L9.11876 4.45196Z"
      stroke="#1369E9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WorkOrderPanelTimerSvg = ({ stroke = '#1369E9' }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.00033 5.54102V7.87435L8.45866 8.74935M7.00033 2.91602C4.26191 2.91602 2.04199 5.13594 2.04199 7.87435C2.04199 10.6128 4.26191 12.8327 7.00033 12.8327C9.73874 12.8327 11.9587 10.6128 11.9587 7.87435C11.9587 5.13594 9.73874 2.91602 7.00033 2.91602ZM7.00033 2.91602V1.16602M5.83366 1.16602H8.16699M11.8589 3.26137L10.9839 2.38637L11.4214 2.82387M2.14175 3.26137L3.01675 2.38637L2.57925 2.82387"
      stroke={stroke || '#1369E9'}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TripCardClockSvg = ({ stroke = '#1369E9' }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3479_748)">
      <path
        d="M6 3V6L8 7M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3479_748">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WorkOrderDetailsLogo = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 12.0001L11.6422 16.8212C11.7734 16.8868 11.839 16.9196 11.9078 16.9325C11.9687 16.9439 12.0313 16.9439 12.0922 16.9325C12.161 16.9196 12.2266 16.8868 12.3578 16.8212L22 12.0001M2 17.0001L11.6422 21.8212C11.7734 21.8868 11.839 21.9196 11.9078 21.9325C11.9687 21.9439 12.0313 21.9439 12.0922 21.9325C12.161 21.9196 12.2266 21.8868 12.3578 21.8212L22 17.0001M2 7.00006L11.6422 2.17895C11.7734 2.11336 11.839 2.08056 11.9078 2.06766C11.9687 2.05622 12.0313 2.05622 12.0922 2.06766C12.161 2.08056 12.2266 2.11336 12.3578 2.17895L22 7.00006L12.3578 11.8212C12.2266 11.8868 12.161 11.9196 12.0922 11.9325C12.0313 11.9439 11.9687 11.9439 11.9078 11.9325C11.839 11.9196 11.7734 11.8868 11.6422 11.8212L2 7.00006Z"
      stroke="#101828"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WorkOrderDetailsMenuSVG = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.33398 9.66638L7.76214 12.8805C7.84959 12.9242 7.89332 12.9461 7.93919 12.9547C7.97981 12.9623 8.02149 12.9623 8.06212 12.9547C8.10798 12.9461 8.15171 12.9242 8.23917 12.8805L14.6673 9.66638M1.33398 6.33305L7.76214 3.11897C7.84959 3.07525 7.89332 3.05338 7.93919 3.04478C7.97981 3.03716 8.02149 3.03716 8.06212 3.04478C8.10798 3.05338 8.15171 3.07525 8.23917 3.11897L14.6673 6.33305L8.23917 9.54713C8.15171 9.59085 8.10798 9.61272 8.06212 9.62132C8.02149 9.62895 7.97981 9.62895 7.93919 9.62132C7.89332 9.61272 7.84959 9.59085 7.76214 9.54713L1.33398 6.33305Z"
      stroke="#101828"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WorkOrderMenuSVG = () => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.25 9L7.25 9M16.25 4.5L7.25 4.5M16.25 13.5L7.25 13.5M4.25 9C4.25 9.41421 3.91421 9.75 3.5 9.75C3.08579 9.75 2.75 9.41421 2.75 9C2.75 8.58579 3.08579 8.25 3.5 8.25C3.91421 8.25 4.25 8.58579 4.25 9ZM4.25 4.5C4.25 4.91421 3.91421 5.25 3.5 5.25C3.08579 5.25 2.75 4.91421 2.75 4.5C2.75 4.08579 3.08579 3.75 3.5 3.75C3.91421 3.75 4.25 4.08579 4.25 4.5ZM4.25 13.5C4.25 13.9142 3.91421 14.25 3.5 14.25C3.08579 14.25 2.75 13.9142 2.75 13.5C2.75 13.0858 3.08579 12.75 3.5 12.75C3.91421 12.75 4.25 13.0858 4.25 13.5Z"
      stroke="#1369E9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ActivityMenuSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
    <path
      d="M6.88793 0.600098L0.950233 7.72533C0.717694 8.00438 0.601424 8.1439 0.599647 8.26174C0.598103 8.36418 0.64375 8.46163 0.723433 8.52603C0.815094 8.6001 0.996713 8.6001 1.35995 8.6001H6.22126L5.5546 13.9334L11.4923 6.8082C11.7248 6.52915 11.8411 6.38963 11.8429 6.27179C11.8444 6.16935 11.7988 6.07189 11.7191 6.0075C11.6274 5.93343 11.4458 5.93343 11.0826 5.93343H6.22126L6.88793 0.600098Z"
      stroke="#000000"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ScheduleMenuSVG = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.33301 8.66675H5.33301M1.33301 6.00008L2.66634 6.66675L3.51344 4.12546C3.68829 3.60092 3.77571 3.33864 3.93787 3.14474C4.08106 2.9735 4.26495 2.84096 4.47268 2.75926C4.70791 2.66675 4.98437 2.66675 5.53729 2.66675H10.4621C11.015 2.66675 11.2914 2.66675 11.5267 2.75926C11.7344 2.84096 11.9183 2.9735 12.0615 3.14474C12.2236 3.33864 12.3111 3.60092 12.4859 4.12546L13.333 6.66675L14.6663 6.00008M10.6663 8.66675H12.6663M4.53301 6.66675H11.4663C12.5864 6.66675 13.1465 6.66675 13.5743 6.88473C13.9506 7.07648 14.2566 7.38244 14.4484 7.75877C14.6663 8.18659 14.6663 8.74664 14.6663 9.86675V11.6667C14.6663 11.9765 14.6663 12.1314 14.6407 12.2602C14.5355 12.7891 14.122 13.2026 13.5931 13.3078C13.4643 13.3334 13.3094 13.3334 12.9997 13.3334H12.6663C11.93 13.3334 11.333 12.7365 11.333 12.0001C11.333 11.816 11.1838 11.6667 10.9997 11.6667H4.99967C4.81558 11.6667 4.66634 11.816 4.66634 12.0001C4.66634 12.7365 4.06939 13.3334 3.33301 13.3334H2.99967C2.6899 13.3334 2.53502 13.3334 2.40622 13.3078C1.8773 13.2026 1.46384 12.7891 1.35863 12.2602C1.33301 12.1314 1.33301 11.9765 1.33301 11.6667V9.86675C1.33301 8.74664 1.33301 8.18659 1.55099 7.75877C1.74274 7.38244 2.0487 7.07648 2.42503 6.88473C2.85285 6.66675 3.4129 6.66675 4.53301 6.66675Z"
      stroke="#1369E9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QuoteMenuSVG = () => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.25 15.75H10.25M2.375 16.125L6.53695 14.5242C6.80316 14.4219 6.93626 14.3707 7.06079 14.3038C7.1714 14.2444 7.27685 14.1759 7.37603 14.099C7.48769 14.0123 7.58853 13.9115 7.79021 13.7098L16.25 5.25C17.0784 4.42157 17.0784 3.07843 16.25 2.25C15.4216 1.42157 14.0784 1.42157 13.25 2.25L4.79021 10.7098C4.58853 10.9115 4.48769 11.0123 4.40104 11.124C4.32408 11.2231 4.25555 11.3286 4.19618 11.4392C4.12933 11.5637 4.07814 11.6968 3.97575 11.9631L2.375 16.125ZM2.375 16.125L3.91859 12.1117C4.02905 11.8245 4.08428 11.6809 4.17901 11.6152C4.26179 11.5577 4.36423 11.5359 4.46322 11.5548C4.5765 11.5765 4.68529 11.6853 4.90286 11.9028L6.59718 13.5972C6.81475 13.8147 6.92354 13.9235 6.94517 14.0368C6.96408 14.1358 6.94234 14.2382 6.88486 14.321C6.81908 14.4157 6.67549 14.471 6.3883 14.5814L2.375 16.125Z"
      stroke="#101828"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InvoiceMenuSVG = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 10.6666C4 12.1393 5.19391 13.3333 6.66667 13.3333H9.33333C10.8061 13.3333 12 12.1393 12 10.6666C12 9.19383 10.8061 7.99992 9.33333 7.99992H6.66667C5.19391 7.99992 4 6.80601 4 5.33325C4 3.86049 5.19391 2.66659 6.66667 2.66659H9.33333C10.8061 2.66659 12 3.86049 12 5.33325M8 1.33325V14.6666"
      stroke="#1369E9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DraftSaveIcon = (props: { stroke: string }) => {
  const { stroke } = props;
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 5.33333H5.73333C5.35997 5.33333 5.17328 5.33333 5.03067 5.26067C4.90523 5.19676 4.80324 5.09477 4.73933 4.96933C4.66667 4.82672 4.66667 4.64004 4.66667 4.26667V2M11.3333 14V9.73333C11.3333 9.35997 11.3333 9.17328 11.2607 9.03067C11.1968 8.90523 11.0948 8.80324 10.9693 8.73933C10.8267 8.66667 10.64 8.66667 10.2667 8.66667H5.73333C5.35997 8.66667 5.17328 8.66667 5.03067 8.73933C4.90523 8.80324 4.80324 8.90523 4.73933 9.03067C4.66667 9.17328 4.66667 9.35997 4.66667 9.73333V14M14 6.21699V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.0799 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H9.78301C10.1091 2 10.2722 2 10.4256 2.03684C10.5617 2.0695 10.6918 2.12337 10.811 2.19648C10.9456 2.27894 11.0609 2.39424 11.2915 2.62484L13.3752 4.7085C13.6058 4.9391 13.7211 5.0544 13.8035 5.18895C13.8766 5.30825 13.9305 5.43831 13.9632 5.57436C14 5.72781 14 5.89087 14 6.21699Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InvoiceInfoAlertIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99984 13.3333V10M9.99984 6.66667H10.0082M18.3332 10C18.3332 14.6024 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6024 1.6665 10C1.6665 5.39763 5.39746 1.66667 9.99984 1.66667C14.6022 1.66667 18.3332 5.39763 18.3332 10Z"
      stroke="#1369E9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PencilEditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.66675 14.3333L5.36626 12.9105C5.60289 12.8194 5.7212 12.7739 5.83189 12.7145C5.93021 12.6617 6.02395 12.6008 6.11211 12.5324C6.21136 12.4554 6.301 12.3658 6.48027 12.1865L14.0001 4.66668C14.7365 3.9303 14.7365 2.73639 14.0001 2.00001C13.2637 1.26363 12.0698 1.26363 11.3334 2.00001L3.8136 9.51982C3.63433 9.69909 3.5447 9.78873 3.46768 9.88798C3.39926 9.97614 3.33835 10.0699 3.28557 10.1682C3.22615 10.2789 3.18065 10.3972 3.08964 10.6338L1.66675 14.3333ZM1.66675 14.3333L3.03883 10.766C3.13701 10.5107 3.1861 10.3831 3.27031 10.3246C3.34389 10.2735 3.43495 10.2542 3.52294 10.271C3.62364 10.2902 3.72034 10.3869 3.91374 10.5803L5.4198 12.0864C5.6132 12.2798 5.7099 12.3765 5.72912 12.4772C5.74593 12.5652 5.7266 12.6562 5.67551 12.7298C5.61704 12.814 5.48941 12.8631 5.23413 12.9613L1.66675 14.3333Z"
      stroke="#1369E9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WorkOrderFolderSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10.8337 5.83333L9.90404 3.9741C9.6365 3.439 9.50271 3.17144 9.30313 2.97597C9.12664 2.80311 8.91393 2.67164 8.68039 2.59109C8.4163 2.5 8.11716 2.5 7.5189 2.5H4.33366C3.40024 2.5 2.93353 2.5 2.57701 2.68166C2.2634 2.84144 2.00844 3.09641 1.84865 3.41002C1.66699 3.76654 1.66699 4.23325 1.66699 5.16667V5.83333M1.66699 5.83333H14.3337C15.7338 5.83333 16.4339 5.83333 16.9686 6.10582C17.439 6.3455 17.8215 6.72795 18.0612 7.19836C18.3337 7.73314 18.3337 8.4332 18.3337 9.83333V13.5C18.3337 14.9001 18.3337 15.6002 18.0612 16.135C17.8215 16.6054 17.439 16.9878 16.9686 17.2275C16.4339 17.5 15.7338 17.5 14.3337 17.5H5.66699C4.26686 17.5 3.5668 17.5 3.03202 17.2275C2.56161 16.9878 2.17916 16.6054 1.93948 16.135C1.66699 15.6002 1.66699 14.9001 1.66699 13.5V5.83333Z"
      stroke="#D0D5DD"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StartWork = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    {' '}
    <path
      d="M3.33594 3.32764C3.33594 2.6802 3.33594 2.35648 3.47093 2.17803C3.58853 2.02257 3.76829 1.92637 3.96287 1.91475C4.18623 1.90142 4.45558 2.08099 4.99428 2.44012L12.0047 7.1137C12.4498 7.41045 12.6723 7.55883 12.7499 7.74584C12.8177 7.90935 12.8177 8.0931 12.7499 8.2566C12.6723 8.44362 12.4498 8.59199 12.0047 8.88874L4.99428 13.5623C4.45558 13.9215 4.18623 14.101 3.96287 14.0877C3.76829 14.0761 3.58853 13.9799 3.47093 13.8244C3.33594 13.646 3.33594 13.3222 3.33594 12.6748V3.32764Z"
      stroke="#101828"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />{' '}
  </svg>
);
